import { render, staticRenderFns } from "./launch-header-blank-v2.vue?vue&type=template&id=1bacf04d&scoped=true&"
import script from "./launch-header-blank-v2.vue?vue&type=script&lang=ts&"
export * from "./launch-header-blank-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bacf04d",
  null
  
)

export default component.exports